import React from 'react';
import { string, shape } from 'prop-types';
import Box from '@magalu/stereo-ui/atoms/Box';
import Text from '@magalu/stereo-ui/atoms/Text';
import { Image } from '@magalu/stereo-ui/atoms';
import currencyFormatter from '@magalu/stereo-ui-utils/currencyFormatter';
import withLayoutProps from '../../../../../hocs/withLayoutProps';
import { ContentInfo, ContentProduct, TextBestPrice, TextPrice, PriceContainer } from './ShareLinksProduct.styles';
var ShareLinksProduct = function ShareLinksProduct(_ref) {
  var _product$image;
  var description = _ref.description,
    data = _ref.data,
    device = _ref.device;
  var product = data.product;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    productPrice = _ref2.price;
  var _ref3 = productPrice || {},
    bestPrice = _ref3.bestPrice,
    price = _ref3.price;
  return React.createElement(ContentInfo, {
    "data-testid": "share-links-product"
  }, description && React.createElement(Text, {
    as: "p",
    lineHeight: 1.2,
    height: "48px"
  }, description), React.createElement(Text, {
    as: "p",
    lineHeight: 1.2,
    paddingTop: 2
  }, "Pr\xE9-visualiza\xE7\xE3o:"), React.createElement(ContentProduct, {
    device: device
  }, React.createElement(Box, {
    p: 3
  }, React.createElement(Image, {
    borderRadius: "10px",
    src: product == null ? void 0 : (_product$image = product.image) == null ? void 0 : _product$image.replace('{w}x{h}', '300x160'),
    alt: product == null ? void 0 : product.title,
    style: {
      maxHeight: '160px'
    }
  })), React.createElement(PriceContainer, null, React.createElement(TextPrice, null, currencyFormatter({
    value: price
  })), React.createElement(TextBestPrice, {
    fontSize: 1,
    fontWeight: "medium",
    color: "white"
  }, currencyFormatter({
    value: bestPrice
  })))));
};
process.env.NODE_ENV !== "production" ? ShareLinksProduct.propTypes = {
  data: shape({
    product: shape({
      image: string,
      price: shape({
        bestPrice: string,
        price: string
      }),
      title: string
    })
  }),
  description: string,
  device: string
} : void 0;
ShareLinksProduct.defaultProps = {
  data: {},
  description: '',
  device: 'desktop'
};
export default withLayoutProps(ShareLinksProduct);